import { render, staticRenderFns } from "./GiteeAccountModal.vue?vue&type=template&id=48a84a74&"
import script from "./GiteeAccountModal.vue?vue&type=script&lang=js&"
export * from "./GiteeAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GiteeAccountModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GiteeAccountModal.vue
// module id = 2354
// module chunks = 1